module.exports = __webpack_public_path__ + "static/img/xinPinChangXian.0c453be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/xinPinChangXian.jpg
// module id = 1p0f
// module chunks = 1